export default __webpack_public_path__ + "9a96a61ce4ab4c17f925e07c5b3e24bc.svg";